import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class TrustPilot extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {number}
   */
  userId;

  /**
   * @var {string}
   */
  trustPilotReviewId;

  /**
   * @var {string}
   */
  reviewRating;

  /**
   * @var {string}
   */
  reviewBody;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.userId = model.userId;
    this.trustPilotReviewId = model.trustPilotReviewId;
    this.reviewRating = model.reviewRating;
    this.reviewBody = model.reviewBody;
  }
}
